import React, { FunctionComponent } from 'react';
import { Image, StyleSheet, Text, View } from 'react-native';
import FastImage from 'react-native-fast-image';
import { connect } from 'react-redux';
import Theme from '../../../theme';
import { defaultScale } from '../../../utils/scaling';
import { IPlayerState } from './interfaces';
import { ISong } from './interfaces';
import MusicControlButtons from './MusicControlButtons';
import { PlayingSongInfo } from './PlayingSongInfo';
import {
  getMusicPlayerStateSelector,
  getPlayingSongSelector,
  getPremiumUserSelector
} from './selectors';
import { truncate } from './SongListItem';
import { WarningMessage } from './WarningMessage';

interface IProps {
  playerState: IPlayerState | null;
  premiumUser: boolean;
  playingSong: ISong | null;
}

export const tileImages = {
  PLACEHOLDER: require('../../../assets/images/fb-star-icon.png'),
};

const MusicControlSection: FunctionComponent<IProps> = ({ playerState, playingSong, ...props }) => {

  const playingSongInfo = () => {
    if (playingSong) {
      return (
        <PlayingSongInfo bottomText={truncate(playingSong.title, 35)} topText={truncate(playingSong.artist, 35)}/>
      );
    }
  };

  if (playerState) {
    return (
      <View style={{ flex: 1, alignItems: 'center', justifyContent: 'space-evenly', marginHorizontal: defaultScale(10) }}>
        <View style={styles.tile}>
          {
            playingSong && playingSong.image &&
            <FastImage
              style={{ width: styles.tile.width, height: styles.tile.height }}
              source={{
                uri: playingSong.image,
              }}
              resizeMode={FastImage.resizeMode.contain}
            />
          }
          {
            !playingSong || !playingSong.image &&
            <FastImage
              style={{ width: styles.tile.width, height: styles.tile.height}}
              source={Image.resolveAssetSource(require('../../../assets/images/fitbeat-music-star.jpg'))}
            />
          }
        </View>
        {playingSongInfo()}
        <MusicControlButtons/>
        {
          !props.premiumUser &&
          <WarningMessage message={'Free Spotify limits skip, back and shuffle'} style={{ paddingVertical: defaultScale(3) }}/>
        }
      </View>
    );
  }
  return <></>;
};

const mapStateToProps = (state: any): Partial<IProps> => {
  return {
    playerState: getMusicPlayerStateSelector(state),
    premiumUser: getPremiumUserSelector(state),
    playingSong: getPlayingSongSelector(state),
  };
};

export default connect(mapStateToProps)(MusicControlSection);

const styles = StyleSheet.create({
  headerTextStyle: {
    zIndex: 1,
    paddingBottom: defaultScale(10),
    borderBottomWidth: defaultScale(2),
    borderBottomColor: Theme.GREY_LIGHT,
  },
  mediaControlIcon: {
    color: Theme.PRIMARY,
  },
  permissionError: {
    minHeight: defaultScale(20),
    margin: defaultScale(5),
  },
  tile: {
    borderWidth: defaultScale(2),
    borderColor: Theme.CHARCOAL,
    width: defaultScale(140),
    height: defaultScale(140),
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 5,
    backgroundColor: Theme.CHARCOAL,
  },
});
